import React from 'react';

import ApiKeys from 'app/collections/api_keys';
import DropdownSelections from 'app/collections/dropdown_selections';
import ApiKey from 'app/models/api_key';
import ApiModeSelection from 'app/models/api_mode_selection';

import Base from 'app/views/base';

import BackboneView from 'app/components/backbone_view';
import PageHeader from 'app/components/page_header_react';
import CardList from 'app/components/card_list';
import PopupCreateFormView from 'app/components/popup_create_form';
import ListItemView from './list_item_view';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'api-keys',

  initialize() {
    this.collection = new ApiKeys([], {});

    this.addReactComponent(
      'header',
      <PageHeader
        name="API Keys"
        links={[
          { name: 'Docs', href: '/docs/api#authentication' },
          { name: 'Guide', href: '/getting-started' },
        ]}
      >
        <BackboneView
          View={PopupCreateFormView}
          viewProps={() => ({
            title: 'Add Additional API Key',
            objectName: 'API Key',
            ModelClass: ApiKey,
            dropdownSelections: new DropdownSelections([
              new ApiModeSelection({}),
            ]),
            onCreate: () => this.collection.fetch({ reset: true }),
          })}
          wrapperTag="span"
        />
      </PageHeader>,
    );
    this.addSubview('prodApiKeysList', '#prod_api_keys_list', new CardList({
      title: 'Production API Keys',
      ListItemView,
      collection: this.collection,
      contextWhere: { mode: 'production' },
    }));
    this.addSubview('testApiKeysList', '#test_api_keys_list', new CardList({
      title: 'Test API Keys',
      ListItemView,
      collection: this.collection,
      contextWhere: { mode: 'test' },
      fetch: false,
    }));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/api_keys/index.jsx